<div class="bg-[#D74141] w-[44px] h-[20px] rounded-[4px] text-white flex items-center justify-center text-xs ml-[6px]">Новое</div>